import { render } from "./ProjectSingleHeader.vue?vue&type=template&id=598e2e09"
import script from "./ProjectSingleHeader.vue?vue&type=script&lang=js"
export * from "./ProjectSingleHeader.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__